module.exports = __webpack_public_path__ + "static/media/background.85c4de62.png";